<ng-container [formGroup]="form">
	<mat-form-field>
		<input
			autocomplete="company-name"
			matInput
			formControlName="companyName"
			placeholder="Company Name"
			required
			maxlength="50"
		/>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="employer-id-number"
			matInput
			formControlName="employerIdentificationNumber"
			placeholder="Employer ID Number"
			maxlength="10"
		/>
	</mat-form-field>
	<mat-form-field *ngIf="isFlairdocsCustomer">
		<input
			autocomplete="off"
			matInput
			readonly
			matTooltip="This field is not editable"
			maxlength="256"
			placeholder="Flairdocs Customer Id"
			formControlName="flairDocsCustomerId"
		/>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="billing-email"
			matInput
			formControlName="billingEmail"
			placeholder="Billing Email"
			type="email"
			required
			maxlength="256"
		/>
		<mat-error *ngIf="form.get('billingEmail').hasError('email')">
			Invalid email address.
		</mat-error>
		<mat-error *ngIf="form.get('billingEmail').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
</ng-container>
